/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I copy the colours?`)
};

const es_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo copiar los colores?`)
};

const de_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich die Farben kopieren?`)
};

const nl_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik de kleuren kopiëren?`)
};

const fr_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je copier les couleurs ?`)
};

const it_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso copiare i colori?`)
};

const pt_br2_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso copiar as cores?`)
};

const pt_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso copiar as cores?`)
};

const ja_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色をコピーできますか?`)
};

const zh_cp_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我能复制这些颜色吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_q4", locale)
	if (locale === "en") return en_cp_faq_q4(inputs)
	if (locale === "es") return es_cp_faq_q4(inputs)
	if (locale === "de") return de_cp_faq_q4(inputs)
	if (locale === "nl") return nl_cp_faq_q4(inputs)
	if (locale === "fr") return fr_cp_faq_q4(inputs)
	if (locale === "it") return it_cp_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_q4(inputs)
	if (locale === "pt") return pt_cp_faq_q4(inputs)
	if (locale === "ja") return ja_cp_faq_q4(inputs)
	return zh_cp_faq_q4(inputs)
};